export const STATUS_BADGE_STYLES = {
  NEW: "bg-gray-200 text-gray-800 border-gray-300",
  ONBOARDING: "bg-blue-200 text-blue-800 border-blue-300",
  GESTATING: "bg-yellow-200 text-yellow-800 border-yellow-300",
  LIVE: "bg-green-200 text-green-800 border-green-300",
  DEAD: "bg-red-200 text-red-800 border-red-300",
  TEST: "bg-purple-200 text-purple-800 border-purple-300",
} as const;
